import { render } from "./GoyaDominanceMobile.vue?vue&type=template&id=6e7e3e98"
import script from "./GoyaDominanceMobile.vue?vue&type=script&lang=js"
export * from "./GoyaDominanceMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__